import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const FileUploadTheme = {
    fileUpload: {
        light: {
            plusIconColor: Colors.accessibleSafetyOrange,
            // TODO: this is an overwrite due to https://polestarjira.atlassian.net/browse/PCW-6363 - adjust to token when available
            successIconColor: 'rgb(6, 169, 89)',
            retryIconColor: withOpacity(Colors.black, Opacities.medium),
            borderColor: withOpacity(Colors.black, Opacities.low),
            borderColorDrop: Colors.black,
            borderColorError: Colors.error,
            thumbnailBackgroundColor: Colors.signalWhite,
            progressColor: withOpacity(Colors.black, Opacities.medium),
        },
        dark: {
            retryIconColor: withOpacity(Colors.white, Opacities.medium),
            borderColor: withOpacity(Colors.white, Opacities.low),
            borderColorDrop: Colors.white,
            thumbnailBackgroundColor: Colors.ironGrey,
            progressColor: withOpacity(Colors.white, Opacities.medium),
        },
    },
};
export default FileUploadTheme;
